import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as PopupActions } from '../constants/PopupConstants';
import { actions as GuestActions } from '../constants/GuestConstants';
import { actions as AuthActions } from '../constants/AuthConstants';

import { events as PopupEvents } from '../constants/PopupConstants';

var _state = {
    pages : []
};

class PopupStoreClass extends EventEmitter {

    getState() {
        return _state;
    }

    open(page, data, guest) {
        if (_state.pages.length > 0)
            this.emitChange(_state.pages[_state.pages.length - 1])
        else
            this.emitChange({ page : false, data : false, guest : false });
    }

    emitChange( callback ) {
        this.emit(PopupEvents.CHANGE_EVENT, callback)
    }

    addChangeListener( callback ) {
        this.on(PopupEvents.CHANGE_EVENT, callback)
    }

    removeChangeListener( callback ) {
        this.removeListener(PopupEvents.CHANGE_EVENT, callback)
    }
}

const PopupStore = new PopupStoreClass();

PopupStore.dispatchToken = AppDispatcher.register(action => {

    switch(action.actionType) {

        case PopupActions.OPEN:
            if (action.page)
                _state.pages.push({ page : action.page, data : action.data, guest: action.guest });
            else
                _state.pages.pop();

            PopupStore.open(action.page, action.data, action.guest);
            break;

        case GuestActions.GUEST_LOAD_FAIL:
            _state.pages = [];
            PopupStore.open(false, false, false);
            break;

        case PopupActions.OPEN_DELIVERY:
            PopupStore.emitChange({ page : 'delivery', shipmentId : action.shipmentId, guest : action.guest });
            break;

        case AuthActions.LOGIN:
            if (action.error)
                PopupStore.emitChange({ page : 'vg-error', data : action.error, guest : false });
            break;
    }
});

export default PopupStore



// WEBPACK FOOTER //
// ./ui_src/app/stores/PopupStore.jsx